import React from 'react'
import PropTypes from 'prop-types'
import {STEPS} from '../../../../constants'
import { Header, Divider, Button } from 'semantic-ui-react'

import {getLanguageScope} from '../../../../helpers'
const _i18n = getLanguageScope('app_not_found');

export default function AppNotFound({changeStep}) {
  return (
    <div>
      <Header as={'h2'} textAlign={'center'} content={_i18n('not_found')} />
      <Header as={'h3'} textAlign={'center'} content={_i18n('support')} />

      <Divider />

      <Button className='block-center' onClick={() => changeStep(STEPS.CATEGORIES)}>{_i18n('back')}</Button>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Applications/AppNotFound/components/AppNotFoundView.js